import { Grid, Stack } from '@mui/material'
import { Button } from '@uy3/web-components';
import { TextFormField } from 'components/Forms/FormFields';

type DisapproveManualWarrantyProps = {
    onCancel: () => void;
    isCancelAction: boolean;
    isCancelDisabled: boolean;
    isLoading: boolean;
}

export const DisapproveManualWarranty = ({ isCancelAction, isCancelDisabled, onCancel, isLoading }: DisapproveManualWarrantyProps) => {
    return (
        <Stack spacing={2} mt={2}>
            <Grid>
                <TextFormField
                    name='message'
                    variant='outlined'
                    label="Mensagem"
                    fullWidth
                    multiline
                    rows={3}
                    required={true}
                />
            </Grid>

            <Stack spacing={2} direction="row" justifyContent="flex-end" alignItems="center">
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onCancel}
                    size="medium"
                >
                    Voltar
                </Button>
                <Button
                    variant="contained"
                    color={isCancelAction ? 'secondary' : 'primary'}
                    size="medium"
                    type='submit'
                    disabled={isCancelDisabled || isLoading}
                >
                    {isCancelAction ? 'Cancelar Garantia' : 'Reprovar Garantia'}
                </Button>
            </Stack>
        </Stack>
    )
}
